/**
 * @name EnrollmentScheduleStatus
 * @description 아동의 일정 상태
 * @type {Object}
 * @property {string} PENDING - 대기
 * @property {string} IN_PROGRESS - 진행
 * @property {string} COMPLETED - 완료
 */
export const EnrollmentScheduleStatus = {
  PENDING: '대기',
  IN_PROGRESS: '진행',
  COMPLETED: '완료',
} as const;

/**
 * @name EnrollmentScheduleType
 * @description 아동의 일정 유형
 * @type {Object}
 * @property {string} COUNSELING - 상담
 * @property {string} TREATMENT - 치료
 * @property {string} SUPPLEMENT - 보강
 */
export const EnrollmentScheduleType = {
  COUNSELING: '상담',
  TREATMENT: '치료',
  SUPPLEMENT: '보강',
} as const;

export const ScheduleType = {
  PERSONAL: '개인',
  CENTER: '센터',
} as const;

export const ScheduleSearchType = {
  PERSONAL: '개인',
  CENTER: '센터',
  TREATMENT: '치료/상담',
} as const;

export const ScheduleCenterSearchType = {
  CURRENT_CENTER: '선택 센터',
  ALL: '전체 센터',
} as const;

export type ScheduleSearchDateType = 'day' | 'week' | 'month';

export const RepeatScheduleUpdateType = {
  THIS: '이 일정',
  THIS_AND_FUTURE: '이 일정 및 향후 일정',
  ALL: '모든 일정',
} as const;
